import React,{useEffect, useState} from "react";
import { $ } from "react-jquery-plugin";
import CommonComponent from './common-components/commonComponent'
// import Dashboard from "./components/dashboard/dashboardComponent"
import Dashboard from "./components/dashboard/dashboard"
import DashboardNew from "./components/dashboard/dashboardComponent"
import Login from './components/login/LoginComponent'
import Degree from "./components/master/degree/DegreeList";
import AddDegree from "./components/master/degree/DegreeAdd";
import EditDegree from "./components/master/degree/DegreeEdit";
import Sports from "./components/master/sports/SportsList";
import AddSports from "./components/master/sports/SportsAdd";
import EditSports from "./components/master/sports/SportsEdit";
import FacultyPositionsList from "./components/master/facultyposition/FacultyPosionList";
import AddFacultyPosition from "./components/master/facultyposition/FacultyPosionAdd";
import EditFacultyPosition from "./components/master/facultyposition/FacultyPositionEdit";
import JobCategory from "./components/master/jobcategories/JobCategoryList";
import AddJobCategory from "./components/master/jobcategories/JobCategoryAdd";
import EditJobCategory from "./components/master/jobcategories/JobCategoryEdit";
import Accreditaions from "./components/master/accreditation/accreditationComponent"
import AccreditaionAdd from "./components/master/accreditation/accreditationAdd"
import AccreditaionEdit from "./components/master/accreditation/accreditationEdit"
import FacultyCategory from "./components/master/facultyCategory/facultyCategory"
import FacultyCategoryAdd from "./components/master/facultyCategory/facultyCategoryAdd"
import FacultyCategoryEdit from "./components/master/facultyCategory/facultyCategoryEdit"
import LinksComponent from "./components/master/links/linksComponent"
import LinksEditComponent from "./components/master/links/linkEdit"
import LinksAddComponent from "./components/master/links/linkAdd"
import GisaApprove from "./components/master/foreignExchange/gisaApprovedList";
import AddGisaforeign from "./components/master/foreignExchange/GisaForeignAdd";
import EditGisaProgram from "./components/master/foreignExchange/GisaForeignEdit";
import EditCsiet from "./components/master/foreignExchange/NewForeignEdit";
import JobComponent from "./components/schools/job/jobList"
import AddJobComponent from "./components/schools/job/jobAdd"
import EditJobComponent from "./components/schools/job/jobEdit"
import FacultyList from "./components/schools/faculty/facultyList"
import FacultyAdd from "./components/schools/faculty/facultyAdd"
import FacultyEdit from "./components/schools/faculty/facultyEdit"
import SchoolProfile from "./components/school_profile/schoolProfile"
import SchoolProfileList from "./components/school_profile/schoolProfileList"
import AddSchoolProfile from "./components/school_profile/schoolProfileAdd"
import EditSchoolProfile from "./components/school_profile/schoolProfileEdit"
import SchoolList from "./components/schools/schoolList"

import SchoolAdd from "./components/schools/schoolAdd"
import AthletList from "./components/schools/athlet/AthletList";
import EditAthlet from "./components/schools/athlet/athletEdit"
import AssociationList from "./components/associations/associationCompenent";
import Addassociation from "./components/associations/associationAdd";
import Editassociation from "./components/associations/associationEdit";
// import EventList from "./components/events/eventsComponent";
import RulesList from "./components/rules/rulesComponent";
import ReportList from "./components/reports/reportsComponent";
import Configuarations from "./components/configurations/configurationComponent";
import SchoolEdit from "./components/schools/schoolEdit"
import ViewLink from "./components/master/links/linkView";
import ViewFaculty from "./components/schools/faculty/facultyView";
import ViewJob from "./components/schools/job/jobsView";
import MemberList from "./components/schools/members/memberList";
import MemberAdd from "./components/schools/members/memberAdd";
import EditMember from "./components/schools/members/memberEdit";
import CountyList from "./components/master/county/countyComponent";
import CountyAdd from "./components/master/county/countyAdd";
import CountyEdit from "./components/master/county/countyEdit";
import RegionList from "./components/master/region/regionComponent";
import RegionAdd from "./components/master/region/regionAdd";
import RegionEdit from "./components/master/region/regionEdit"; 
import AddAthlet from "./components/schools/athlet/athletAdd";
import AthletView from "./components/schools/athlet/athletView";
import Description from "./components/schools/job/jobDescription"
import Questions from "./components/questions/Questions";
import AssociationOfficials from "./components/associations/official/officialsList"
import AssociationView from "./components/associations/associationView";
import AddOfficials from "./components/associations/official/officialsAdd";
import EditOfficials from "./components/associations/official/officialsEdit";
import OfficialView from "./components/associations/official/officialView";

import AddRules from "./components/rules/addRules";
import EditRules from "./components/rules/editRules";
import RulesQuestionList from "./components/rules/rulesQuestionList";
import CreateQuest from "./components/rules/CreateQuest";
import StaffList from "./components/associations/staff/staffList";
import Certificate from "./common-components/Certificate";
import EditRuleQuestion from "./components/rules/rulesQuestionEdit";
import Payment from "./components/registerFormOfficials.js/Payment";
import ResetPassword from "./components/login/ResetPassword";
// import Configurations from "./components/configurations/configurationComponent" 
import CoachList from "./components/schools/coach/coachList";
import ResetPermissionPassword from "./components/schools/members/ResetPassword";
import ResetAssociationPassword from "./components/associations/ResetPassword";
import DashboardAthletic from "./components/dashboard/dashboardAthletic";
import DashboardGiaa from "./components/dashboard/dashboardGiaa";
import DashboardFaculty from "./components/dashboard/dashboardFaculty";
import DashboardPermission from "./components/dashboard/dashboardPermission";
import GiaaDashboard from "./components/dashboard/athleticDashboard";
import NewAthleticDashboard from "./components/dashboard/newAthleticDashboard";
import UpdatedAthleticDashboard from "./components/dashboard/updatedAthleticDashboard";
import IneligibleAthleticDashboard from "./components/dashboard/ineligibleAthleticDashboard";
import ApprovedAthleticDashboard from "./components/dashboard/approvedAthleticDashboard";


import { Routes, Route, } from "react-router-dom";  
import EventComponent from "./components/events/seminar/eventComponent";
import AddEvent from "./components/events/seminar/addEvent";
import EventLayOutAdd from "./components/events/seminar/eventAddLay";
import EventView from "./components/events/seminar/eventView";
import EditEvent from "./components/events/seminar/eventEdit";
import EventLayOutEdit from "./components/events/seminar/eventEditLay";
import ListRegisterEvent from "./components/events/register/ListRegisterEvent";
import RegitserListingDetails from "./components/events/seminar/registerListing";
import RegisterView from "./components/events/seminar/registerView";
import AttendeeView from "./components/events/seminar/attendeeView";
import OfficialPayFormUI from "./components/associations/official/officialPayment";
import AssociationOfficialList from "./components/associations/official/assofficialListing";
import AttendeePayment from "./components/events/register/paymentAttendee";
import AssociationSelect from "./components/associations/associationSelect";
import OfficialPendingCheck from "./components/associations/official/OfficialPendingCheck";
import AssociationDashboard from "./components/dashboard/association/AssociationDashboard";
import AssociationMoreDashboard from "./components/dashboard/association/AssociationMoreDashboard";
import WorkshopComponent from "./components/events/workshop/WorkshopListing";
import WorkshopView from "./components/events/workshop/WorkshopView";
import WorkshopCreateLayout from "./components/events/workshop/WorkshopCreateLayout";
import WorkshopUpdateLayout from "./components/events/workshop/WorkshopUpdateLayout";
import SessionsLising from "./components/events/workshop/SessionsListing";
import WorkshopMultiple from "./components/events/workshop/WorkshopMultiple";
import WorkshopMultipleView from "./components/events/workshop/WorkshopMultipleView";
import WorkshopMultipleUpdate from "./components/events/workshop/WorkshopMultipleUpdate";
import WorkshopSessionCreate from "./components/events/workshop/WorkshopSessionsAdd";
import RegisterWorkshopListing from "./components/events/workshop/RegisterWorkshop";
import AttendeeRegisteringWorkshop from "./components/events/workshop/AttendeeRegisteringWorkshop";
import RegisterViewWorkshop from "./components/events/workshop/registerView";
import AttendeesWorkshopMultiple from "./components/events/workshop/AttendeesWorkshopListing";
import MultipleWorkshopCreate from "./components/events/workshop/WorkshopMultipleCreate";
import SessionView from "./components/events/workshop/SessionView";
import WorkshopSessionUpdate from "./components/events/workshop/SessionUpdate";

import MessageScreen from "./components/questions/Message";
import RulesView from "./components/rules/viewRules";
import CoachesView from "./components/rules/viewCoaches";
import CoachListRules from "./components/rules/CoachList";
import SeminarPendingCheck from "./components/events/seminar/checkPaymentList";
import WorkshopPendingCheck from "./components/events/workshop/checkPaymentList";
import Tablecostlist from "./components/master/tablecost/tablecostlist";
import Tablecostadd from "./components/master/tablecost/tablecostadd";
import Tablecostedit from "./components/master/tablecost/tablecostedit";

import Elecostlist from "./components/master/elecCost/elecostlist";
import Elecostadd from "./components/master/elecCost/elecostadd";
import Elecostedit from "./components/master/elecCost/elecostedit";


import ExhibitionAdd from "./components/exhibitions/exhibitionAdd";
import ExhibitionList from "./components/exhibitions/exhibitionlist";
import EditExhibition from "./components/exhibitions/exhibitionEdit";
import ExhibitionView from "./components/exhibitions/exhibitionView";
import ExhibitionRegisterList from "./components/exhibitions/exhibitionRegisterList";
import ExhibitionPendingList from "./components/exhibitions/exhibitionPendingList";
import ExhibitorView from "./components/exhibitions/exhibitorView";
import CoachAnswerslist from "./components/rules/coachAnswers";


const App = () =>{

  const [token, setToken] = useState('')

  useEffect(()=>{
    let storevariable = localStorage.getItem('token');
    setToken(storevariable)
  })
  
  
  

    return( 
      <div>



          <div><CommonComponent /></div>
        <Routes> 
              {/* <Route exact path="/" element={ <Login/> } />   
              <Route path="/admin" exact element={ <AdminLogin/> } />   
              <Route path="/associations/login" exact element={ <AssociationLogin/> } />    */}
              <Route path="/dashboard_new" exact element={ <Dashboard/> } />
              <Route path="/degreelist" exact element={ <Degree/> } />
              <Route path="/add_degree" exact element={ <AddDegree/> } />
              <Route path="/edit_degree/:id" exact element={ <EditDegree/> } />
              <Route path="/sportslist" exact element={ <Sports/>} />
              <Route path="/add_sports" exact element={ <AddSports/>} />
              <Route path="/edit_sports/:id" exact element={ <EditSports/>} />
              <Route path="/facultyposlist" exact element={ <FacultyPositionsList/>} />
              <Route path="/add_facultypos" exact element={ <AddFacultyPosition/>} />
              <Route path="/edit_facultypos/:id" exact element={ <EditFacultyPosition/>} />
              <Route path="/jobcategorylist" exact element={ <JobCategory/>} />
              <Route path="/add_jobcat" exact element={ <AddJobCategory/>} />
              <Route path="/edit_jobcat/:id" exact element={ <EditJobCategory/>} /> 
              <Route path="/accreditation" exact element={ <Accreditaions/>} />
              <Route path="/add_accreditation" exact element={ <AccreditaionAdd/>} />
              <Route path="/edit_accreditation/:id" exact element={ <AccreditaionEdit/>} />
              <Route path="/facultycategory" exact element={ <FacultyCategory/>} />
              <Route path="/add_facultycategory" exact element={ <FacultyCategoryAdd/>} />
              <Route path="/edit_facultycategory/:id" exact element={ <FacultyCategoryEdit/>} />
              <Route path="/links" exact element={ <LinksComponent/>} />
              <Route path="/edit_links/:id" exact element={ <LinksEditComponent/>} />
              <Route path="/add_links" exact element={ <LinksAddComponent/>} />
              <Route path="/gisapprovelist" exact element={ <GisaApprove/>} />
              <Route path="/add_gissaforeign" exact element={ <AddGisaforeign/>} />
              <Route path="/edit_gissaforeign/:id" exact element={ <EditGisaProgram/>} />
              <Route path="/edit_csiet/:id" exact element={ <EditCsiet/>} />
              <Route path="/jobs/:id" exact element={ <JobComponent/> } />
              <Route path="/add_jobs/:id" exact element={ <AddJobComponent/> } />
              <Route path="/edit_jobs/:id/:jobid" exact element={ <EditJobComponent/> } />
              <Route path="/school_list/faculty/:id" exact element={ <FacultyList/>} />
              <Route path="/add_faculty/:id" exact element={ <FacultyAdd/>} />
              <Route path="/edit_faculty/:id/:facid" exact element={ <FacultyEdit/>} />
              <Route path="/school_profile/:id" exact element={ <SchoolProfile/> } />
              <Route path="/school_profile_list" exact element={ <SchoolProfileList/> } />
              <Route path="/add_school_profile" exact element={ <AddSchoolProfile/> } />
              <Route path="/edit_school_profile" exact element={ <EditSchoolProfile/> } />
              <Route path="/school_list" exact element={ <SchoolList/> } />
              
              <Route path="/add_schools" exact element={ <SchoolAdd/> } />
              <Route path="/school_list/athlet_list/:id" exact element={ <AthletList/> } />
              <Route path="/athlet_add/:id" exact element={ <AddAthlet/> } />
              <Route path="/athlet_edit/:sid/:aid" exact element={ <EditAthlet/> } />
              <Route path="/athletView/:sid/:aid" exact element={ <AthletView/> } />
              <Route path="/associations" exact element={ <AssociationList/> } />
              <Route path="/add_associations" exact element={ <Addassociation/> } />
              <Route path="/edit_associations/:id" exact element={ <Editassociation/> } />
              {/* <Route path="/events" exact element={ <EventList/> } /> */}
              <Route path="/rules" exact element={ <RulesList/> } />
              <Route path="/reports" exact element={ <ReportList/> } />
              <Route path="/configurations" exact element={ <Configuarations/> } />
              <Route path="/edit_school/:id" exact element={ <SchoolEdit/> } />
              <Route path="/linkview/:id" exact element={ <ViewLink/> } />
              <Route path="/facultyview/:id/:facid" exact element={ <ViewFaculty/> } />
              <Route path="/jobview/:id/:jobid" exact element={ <ViewJob/> } />
              <Route path="/jobview/:id/:jobid/description_view" exact element={ <Description/> } />
              <Route path="/members/:id" exact element={ <MemberList/> } />
              <Route path="/memberAdd/:id" exact element={ <MemberAdd/> } />
              <Route path="/memberedit/:sid/users/:id" exact element={ <EditMember/> } />
              <Route path="/county_list" exact element={ <CountyList/> } />
              <Route path="/county_add" exact element={ <CountyAdd/> } />
              <Route path="/county_edit/:id" exact element={ <CountyEdit/> } />
              <Route path="/region_list" exact element={ <RegionList/> } />
              <Route path="/region_add" exact element={ <RegionAdd/> } />
              <Route path="/region_edit/:id" exact element={ <RegionEdit/> } />
              <Route path="/questions/:rid" exact element={ <Questions/>} />
              <Route path="/officials/:id" exact element={ <AssociationOfficials/> } />
       	      <Route path="/official_edit/:assid/:id" exact element={ <EditOfficials/> } />
              <Route path="/officialview/:assid/:id" exact element={ <OfficialView/> } />
              <Route path="/associationview/:id" exact element={ <AssociationView/> } />
              <Route path="/addofficials/:id" exact element={ <AddOfficials/> } />
              
              <Route path="/add_rules" exact element={ <AddRules/> } />
              <Route path="/edit_rules/:id" exact element={ <EditRules/> } />
              <Route path="/rules_list_question/:id" exact element={ <RulesQuestionList/> } />
              <Route path="/editRuleQuestion/:ruleid/:qid" exact element={ <EditRuleQuestion/> } />
              <Route path="/create_quest/:ruleid" exact element={ <CreateQuest/> } />
              <Route path="/staffs" exact element={ <StaffList/> } />
              <Route path="/certificate/:rid/" exact element={ <Certificate/> } />
              <Route path="/reset_password" exact element={ <ResetPassword/> } />
              <Route path="/school_list/coach/:id" exact element={ <CoachList/>} />
              <Route path="/resetpermission/:sid/:id" exact element={ <ResetPermissionPassword/>} />
              <Route path="/resetassociationpass/:sid/:id" exact element={ <ResetAssociationPassword/>} />
              {/* <Route path="/dashboard_athletic" exact element={ <DashboardAthletic/>} />
              <Route path="/dashboard_giaa" exact element={ <DashboardGiaa/>} />
              <Route path="/dashboard_faculty" exact element={ <DashboardFaculty/>} />
              <Route path="/dashboard_permission" exact element={ <DashboardPermission/>} /> */}

              <Route path="/dashboard" exact element={ <DashboardNew/> } />
              <Route path="/dashboard_athletic" exact element={ <DashboardAthletic/>} />
              <Route path="/dashboard_giaa" exact element={ <DashboardGiaa/>} />
              <Route path="/dashboard_faculty" exact element={ <DashboardFaculty/>} />
              <Route path="/dashboard_permission" exact element={ <DashboardPermission/>} />
              <Route path="/giaa_dashboard/:id" exact element={ <GiaaDashboard/>} />

              <Route path="/new_athletic_dashboard/:id" exact element={ <NewAthleticDashboard/>} />
              <Route path="/updated_athletic_dashboard/:id" exact element={ <UpdatedAthleticDashboard/>} />
              <Route path="/ineligible_athletic_dashboard/:id" exact element={ <IneligibleAthleticDashboard/>} />
              <Route path="/approved_athletic_dashboard/:id" exact element={ <ApprovedAthleticDashboard/>} />

              <Route path="/conference" exact element={ <EventComponent/>} />
              <Route path="/add_event" exact element={ <EventLayOutAdd/>} />
              <Route path="/view_event/:id" exact element={ <EventView/>} />
              <Route path="/edit_event/:id" exact element={ <EventLayOutEdit/>} />
              {/* <Route path="/register_event/" exact element={ <ListRegisterEvent/>} /> */}
              <Route path="/register_details/:eventid" exact element={<RegitserListingDetails />} />

              <Route path="/register_view/:eventid/:id" exact element={<RegisterView />} />
              <Route path="/attendee_view/:eventid/:id" exact element={<AttendeeView />} />


              <Route path="/officialpayment/:assid/:offid" exact element={<OfficialPayFormUI />} />

              <Route path="/attendeepayment/" exact element={<AttendeePayment />} />

              <Route path='/association_officials/:assid' exact element={<AssociationOfficialList />} /> 

              <Route path='/select_association/' exact element={<AssociationSelect />} /> 


              <Route path='/official/pending/:assoname/:assid' exact element={<OfficialPendingCheck />} /> 

              <Route path='/new_officials/:id' exact element={<AssociationDashboard />} /> 
              <Route path='/dashboard/associations' exact element={<AssociationMoreDashboard />} /> 

              <Route path='/workshop' exact element={<WorkshopComponent />} /> 
              <Route path='/view_workshop/:id' exact element={<WorkshopView />} /> 
              <Route path='/add_workshop' exact element={<WorkshopCreateLayout />} /> 
              <Route path='/update_workshop/:id' exact element={<WorkshopUpdateLayout />} /> 
              <Route path='/sessions/:wid' exact element={<SessionsLising />} /> 
              <Route path='/workshop/session/:wid/:sid' exact element={<WorkshopMultiple />} /> 
              <Route path='/workshop/session/add/:wid/:sid' exact element={<MultipleWorkshopCreate />} /> 
              <Route path='/workshop/session/view/:wid/:sid/:id' exact element={<WorkshopMultipleView/>} /> 
              <Route path='/workshop/session/update/:wid/:sid/:id' exact element={<WorkshopMultipleUpdate/>} /> 
              <Route path='/workshop/create/:wid/' exact element={<WorkshopSessionCreate/>} /> 
              <Route path='/register/workshop/:eventid/' exact element={<RegisterWorkshopListing/>} /> 
              <Route path='/attendee/workshop/:regid/' exact element={<AttendeeRegisteringWorkshop/>} /> 
              <Route path='/register/view/workshop/:eventid/:regid/' exact element={<RegisterViewWorkshop/>} /> 
              <Route path='/workshop/attendees/view/:workname/:wid/:sid/:id/' exact element={<AttendeesWorkshopMultiple/>} /> 
              <Route path='/workshop/session/view/:wid/:sid' exact element={<SessionView/>} /> 
              <Route path='/workshop/session/update/:wid/:sid' exact element={<WorkshopSessionUpdate/>} /> 
              
              <Route path="/quiz/message" exact element={ <MessageScreen /> } />
              <Route path="/rule_view/:id" exact element={ <RulesView /> } />

              <Route path="/coach_view/:id" exact element={ <CoachesView /> } />
              <Route path="/coachanswers/:id" exact element={ <CoachAnswerslist /> } />

              <Route path="/rule_coach/:rid" exact element={ <CoachListRules /> } />
              <Route path="/check_payment/:eventid" exact element={ <SeminarPendingCheck /> } />
              <Route path="/check_payment_conference/:eventid" exact element={ <WorkshopPendingCheck /> } />

              <Route path="/tablecostlist" exact element={ <Tablecostlist/> } />
              <Route path="/add_tablecost" exact element={ <Tablecostadd/> } />
              <Route path="/edit_tablecost/:id" exact element={ <Tablecostedit/> } />

              <Route path="/elecostlist" exact element={ <Elecostlist/> } />
              <Route path="/add_elecost" exact element={ <Elecostadd/> } />
              <Route path="/edit_elecost/:id" exact element={ <Elecostedit/> } />

              
              <Route path="/add_exhibition/" exact element={ <ExhibitionAdd/> } />
              <Route path="/exhibition/" exact element={ <ExhibitionList/> } />
              <Route path="/edit_exhibition/:id" exact element={ <EditExhibition/> } />
              <Route path="/view_exhibition/:id" exact element={ <ExhibitionView/> } />
              <Route path="/exhibition_register/:id" exact element={ <ExhibitionRegisterList/> } />
              <Route path="/exhibition_register_pending/:id" exact element={ <ExhibitionPendingList/> } />
              <Route path="/exhibitor_view/:id" exact element={ <ExhibitorView/> } />
             

        </Routes>
      </div>
    )
};

export default App;
